export default __webpack_public_path__ + "3de5a61d5a6e6c63d9bbe0a02116b7ed.webp";